module.exports = __webpack_public_path__ + "static/img/kira-mason.a8c2192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kira-mason.jpg
// module id = bT5n
// module chunks = 0